// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3OVV7","inner":"Footer_inner__B7keb"};